import { useNavigate } from "react-router-dom";

const BigButton = ({ title, url, icon, onClick }) => {
	const navigate = useNavigate();

	const handleClick = () => {
		if (onClick) {
			onClick();
		} else if (url) {
			navigate(url);
		} else {
			// Check if history has entries
			if (window.history.length > 1) {
				window.history.back();
			} else {
				navigate(url || "/events"); // fallback route
			}
		}
	};

	return (
		<div className="d-flex mt-2">
			<button
				className="btn btn-lg d-flex align-items-center go-back"
				onClick={handleClick}
				style={{
					padding: "5px 0px",
					borderRadius: "50px",
				}}
			>
				<i className={`bi ${icon} me-2`} style={{ fontSize: "2rem" }} />
				{title}
			</button>
		</div>
	);
};

export default BigButton;
